import { IonIcon, IonItem } from "@ionic/react";
import { timeOutline } from "ionicons/icons";
import { ProjectImage } from "@/components/molecules/project/project-image";
import { type Project } from "@/lib/backend/api";
import { Routes } from "@/lib/router";
import { formatInTz, formatTime } from "@/utils/format-datetime";

type ProjectCardFeaturedProps = {
  project: Project;
};

export function ProjectCardFeatured({ project }: ProjectCardFeaturedProps) {
  // Handle user functions - show first one + count of remaining
  const uniqueFunctions = project.stats?.uniqueUserFunctions ?? [];
  const userFunctionsDisplay =
    uniqueFunctions.length === 0
      ? ""
      : uniqueFunctions.length === 1
        ? uniqueFunctions[0]
        : `${uniqueFunctions[0]} +${uniqueFunctions.length - 1}`;

  // Projecttijd, niet toesteltijd: een project dat om 15:00 begint hoort ook op een telefoon in
  // Toronto 15:00 te lezen, en de datum ernaast hoort niet een dag terug te vallen.
  const timeZone = project.timeZone;
  const startDate = project.startDate;

  // Format date as "7 dec"
  const dateDisplay = startDate
    ? formatInTz(startDate, { month: "short", day: "numeric", timeZone })
    : "";

  // Format time from startDate
  const timeDisplay = startDate ? formatTime(startDate, { timeZone }) : "";

  return (
    <IonItem
      button
      detail={false}
      routerLink={Routes.ProjectOverview(
        { id: project.id },
        {
          search: {
            fromUrl: Routes.ProjectShifts({ id: project.id }),
          },
        },
      )}
      routerDirection="forward"
      className="ion-no-padding w-[156px] [--border-width:0] [--inner-padding-end:0] [--padding-end:0] [--padding-start:0]"
      lines="none"
    >
      <div className="flex w-full flex-col gap-2">
        {/* Image */}
        <ProjectImage
          projectId={project.id}
          imageKey={project.image}
          alt={project.name}
          className="aspect-video w-[156px] rounded-xl border border-bordercolor-primary"
        />

        {/* Project info */}
        <div className="flex w-full flex-col gap-1">
          <h3 className="truncate text-ellipsis whitespace-nowrap text-sm font-medium leading-[1.4] text-txt-primary">
            {project.name}
          </h3>
          <div className="flex items-center gap-[6px]">
            <p className="truncate text-xs font-medium leading-[1.4] text-txt-tertiary">
              {userFunctionsDisplay}
            </p>
            {dateDisplay && userFunctionsDisplay && (
              <div className="flex items-center pb-0 pt-[2px]">
                <div className="h-[3px] w-[3px] shrink-0 rounded-full bg-txt-tertiary" />
              </div>
            )}
            {dateDisplay && (
              <p className="text-xs font-medium leading-[1.4] text-txt-tertiary">{dateDisplay}</p>
            )}
          </div>
          {/* Time display */}
          {/* {timeDisplay && (
            <div className="inline-flex items-center gap-2 self-start rounded-full border border-bordercolor-primary px-3 py-1.5">
              <IonIcon icon={timeOutline} className="text-base text-txt-primary" />
              <span className="text-xs font-semibold leading-[1.4] text-txt-primary">
                {timeDisplay}
              </span>
            </div>
          )} */}
        </div>
      </div>
    </IonItem>
  );
}
